export default __webpack_public_path__ + "media/images/coworkr/favicons/icon120-b2a0b3ec7e8ca71b33a8f24d30e655fa.png";